{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/site-tagline",
	"title": "Site Tagline",
	"category": "theme",
	"description": "Describe in a few words what this site is about. This is important for search results, sharing on social media, and gives overall clarity to visitors.",
	"keywords": [ "description" ],
	"textdomain": "default",
	"attributes": {
		"level": {
			"type": "number",
			"default": 0
		},
		"levelOptions": {
			"type": "array",
			"default": [ 0, 1, 2, 3, 4, 5, 6 ]
		}
	},
	"example": {
		"viewportWidth": 350,
		"attributes": {
			"style": {
				"typography": {
					"textAlign": "center"
				}
			}
		}
	},
	"supports": {
		"anchor": true,
		"align": [ "wide", "full" ],
		"html": false,
		"background": {
			"backgroundImage": true,
			"backgroundSize": true,
			"gradient": true
		},
		"color": {
			"gradients": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"contentRole": true,
		"dimensions": {
			"minHeight": true,
			"minWidth": true
		},
		"spacing": {
			"margin": true,
			"padding": true,
			"__experimentalDefaultControls": {
				"margin": false,
				"padding": false
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"textAlign": true,
			"__experimentalFontFamily": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalFontStyle": true,
			"__experimentalFontWeight": true,
			"__experimentalLetterSpacing": true,
			"__experimentalWritingMode": true,
			"fitText": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true
		},
		"shadow": true
	},
	"editorStyle": "wp-block-site-tagline-editor",
	"style": "wp-block-site-tagline"
}
